import React from "react";
import { useCart } from "../../context/CartContext";

const Cart = () => {
  const { cartItems, total, removeFromCart, updateQuantity, clearCart } =
    useCart();
  console.log(cartItems);
  return (
    <div className="container mt-4">
      <h2>🛒 Mon Panier</h2>
      {cartItems.length === 0 ? (
        <p>Votre panier est vide.</p>
      ) : (
        <>
          <ul className="list-group mb-3">
            {cartItems.map((item) => (
              <li
                key={item._id}
                className="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <h6>{item.title}</h6>
                  <p>{item.price} €</p>
                </div>

                <div className="d-flex align-items-center">
                  <input
                    type="number"
                    value={item.quantity}
                    min="1"
                    className="form-control me-2"
                    style={{ width: "70px" }}
                    onChange={(e) => {
                      const q = parseInt(e.target.value, 10);
                      // si tu veux autoriser 0 pour supprimer, utiliser min="0" et laisser la logique du reducer
                      updateQuantity(item._id, isNaN(q) ? 1 : q);
                    }}
                  />
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => removeFromCart(item._id)}>
                    Supprimer
                  </button>
                </div>
              </li>
            ))}
          </ul>
          <h4>Total : {total} €</h4>
          <button className="btn btn-warning" onClick={clearCart}>
            Vider le panier
          </button>
        </>
      )}
    </div>
  );
};

export default Cart;
